<template>
    <app-layout :title="trans('users.page_title.edit')">
        <template #header> {{ trans("users.page_title.edit") }} </template>

        <Section>
            <Container>
                <form @submit.prevent="form.post(url)" id="form">
                    <div
                        class="space-y-8 divide-y divide-gray-200 sm:space-y-5"
                    >
                        <div class="space-y-6 sm:space-y-5">
                            <div class="space-y-6 sm:space-y-5">
                                <div
                                    class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
                                >
                                    <label
                                        for="firstname"
                                        class="block font-medium text-gray-700 sm:mt-px sm:pt-2"
                                    >
                                        {{ trans("users.label.firstname") }}
                                    </label>
                                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                                        <input
                                            type="text"
                                            name="firstname"
                                            id="firstname"
                                            v-model="form.firstname"
                                            class="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
                                            :class="[
                                                {
                                                    'border border-red-500':
                                                        form.errors.firstname,
                                                },
                                            ]"
                                        />
                                        <small
                                            class="text-red-500"
                                            v-if="form.errors.firstname"
                                        >
                                            <strong>{{
                                                form.errors.firstname
                                            }}</strong>
                                        </small>
                                    </div>
                                </div>
                                <div
                                    class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
                                >
                                    <label
                                        for="lastname"
                                        class="block font-medium text-gray-700 sm:mt-px sm:pt-2"
                                    >
                                        {{ trans("users.label.lastname") }}
                                    </label>
                                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                                        <input
                                            type="text"
                                            name="lastname"
                                            id="lastname"
                                            v-model="form.lastname"
                                            class="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
                                            :class="[
                                                {
                                                    'border border-red-500':
                                                        form.errors.lastname,
                                                },
                                            ]"
                                        />
                                        <small
                                            class="text-red-500"
                                            v-if="form.errors.lastname"
                                        >
                                            <strong>{{
                                                form.errors.lastname
                                            }}</strong>
                                        </small>
                                    </div>
                                </div>
                                <div
                                    class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
                                >
                                    <label
                                        for="email"
                                        class="block font-medium text-gray-700 sm:mt-px sm:pt-2"
                                    >
                                        {{ trans("users.label.email") }}
                                    </label>
                                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                                        <input
                                            type="text"
                                            name="email"
                                            id="email"
                                            v-model="form.email"
                                            class="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
                                            :class="[
                                                {
                                                    'border border-red-500':
                                                        form.errors.email,
                                                },
                                            ]"
                                        />
                                        <small
                                            class="text-red-500"
                                            v-if="form.errors.email"
                                        >
                                            <strong>{{
                                                form.errors.email
                                            }}</strong>
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mt-8 sm:mt-0 pt-8 flex justify-end">
                            <button type="submit">
                                <StyledButton background-primary>{{
                                    trans("button.submit")
                                }}</StyledButton>
                            </button>
                        </div>
                    </div>
                </form>
            </Container>
        </Section>
    </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import StyledButton from "@/Components/StyledButton.vue";
import Container from "@/Components/Container.vue";
import Section from "@/Components/Section.vue";
import { Link } from "@inertiajs/inertia-vue3";

export default {
    components: {
        AppLayout,
        StyledButton,
        Link,
        Container,
        Section,
    },

    props: {
        user: Object,
        url: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            form: this.$inertia.form({
                _method: this.user?.id ? "put" : "post",
                firstname: this.user?.firstname ?? "",
                lastname: this.user?.lastname ?? "",
                email: this.user?.email ?? "",
            }),
        };
    },
};
</script>
